import { Button } from "@mui/material";

export const CustomButton = ({
  variant = "contained",
  color = "success",
  fontSize = "1rem",
  fullWidth = false,
  disabled = false,
  type = "button",
  onClick,
  children,
  ...rest
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      color={color}
      variant={variant}
      type={type}
      disabled={disabled}
      onClick={onClick}
      sx={{
        textTransform: "none",
        borderRadius: "4px",
        minWidth: "120px",
        fontSize,
        lineHeight: 1.2,
        px: 2,
        py: 1,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};
